import * as server from '../entries/pages/oplaty-i-platnosci/_page.server.ts.js';

export const index = 11;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/oplaty-i-platnosci/_page.svelte.js')).default;
export { server };
export const server_id = "src/routes/oplaty-i-platnosci/+page.server.ts";
export const imports = ["_app/immutable/nodes/11.CZoTs17t.js","_app/immutable/chunks/Cew_q46a.js","_app/immutable/chunks/DiR_Syld.js","_app/immutable/chunks/DHDEAeFQ.js","_app/immutable/chunks/Dh3qtgeV.js","_app/immutable/chunks/C5PKkLQu.js","_app/immutable/chunks/zAv0u1wk.js","_app/immutable/chunks/B6Ikv-5C.js","_app/immutable/chunks/Bu93Vllf.js"];
export const stylesheets = ["_app/immutable/assets/PageHeadingSection.CpMvHLMT.css","_app/immutable/assets/11.D7FvnKKc.css"];
export const fonts = [];
